import React, { useContext } from 'react';
import List from '@mui/material/List';
import { useTranslation } from 'react-i18next';
import DashboardIcon from '@mui/icons-material/Dashboard';
import DescriptionIcon from '@mui/icons-material/Description';
import SupervisorAccountIcon from '@mui/icons-material/SupervisorAccount';
import VpnKeyIcon from '@mui/icons-material/VpnKey';
import ListSubheader from '@mui/material/ListSubheader';
import AllInboxIcon from '@mui/icons-material/AllInbox';
import DrawerListItem from '../../components/_header/DrawerListItem';
import useRoutes from '../../components/_hook/useRoutes';
import { usePlanQuery } from '../../../graphql/query/plan/usePlanQuery';
import Context from '../../context';
import SuperAdminPermission from '../../adminComponents/_permission/SuperAdminPermission';

export default function PlanDrawer() {
  const { path } = useRoutes();
  const { company } = useContext(Context);
  const { t } = useTranslation();

  const { data } = usePlanQuery(
    `_id
            status
            company
            `,
    {
      variables: { filter: { companyId: company._id as string } },
    }
  );
  const plan = data ? data.plans.items[0] : null;
  return (
    <>
      <List>
        <DrawerListItem
          path={path('plan.dashboard', {
            companyID: company._id,
          })}
          primaryText={t('dashboard')}
          icon={<DashboardIcon />}
        />
        {plan && (
          <>
            <DrawerListItem
              path={path('plan.subscriptions', {
                companyID: company._id,
              })}
              primaryText={t('subscription')}
              icon={<DescriptionIcon />}
              className="plan-drawer-subscription-list-item-joyride"
            />
            <DrawerListItem
              path={path('plan.administrators', {
                companyID: company._id,
              })}
              primaryText={t('administrator')}
              icon={<SupervisorAccountIcon />}
              className="plan-drawer-administrator-list-item-joyride"
            />
            {plan.status && (
              <DrawerListItem
                path={path('plan.access_levels', {
                  companyID: company._id,
                })}
                primaryText={t('access_level')}
                icon={<VpnKeyIcon />}
              />
            )}
            {plan.status && (
              <>
                <SuperAdminPermission>
                  <ListSubheader>{t('subdirectory')}</ListSubheader>
                </SuperAdminPermission>
                <SuperAdminPermission>
                  <span>
                    <DrawerListItem
                      path={path('plan.subdirectory.subscriptions', {
                        companyID: company._id,
                      })}
                      primaryText={t('subscription', { count: 2 })}
                      icon={<AllInboxIcon />}
                    />
                  </span>
                </SuperAdminPermission>
                <SuperAdminPermission>
                  <span>
                    <DrawerListItem
                      path={path('plan.subdirectory.list', {
                        companyID: company._id,
                      })}
                      primaryText={t('subdirectory', { count: 2 })}
                      icon={<AllInboxIcon />}
                    />
                  </span>
                </SuperAdminPermission>
              </>
            )}
          </>
        )}
      </List>
    </>
  );
}
